import { Ballot } from '@db8/shared'
import { useAblyTypedPubSub } from '../use-ably'

export const useBallotsPubSub = ({
  ballots,
  setBallots,
}: {
  ballots: any[]
  setBallots: (val: any[]) => void
}) => {
  const { publish } = useAblyTypedPubSub('BALLOTS', ({ data }) => {
    setBallots(data)
  })

  const publishBallots = (message: Ballot[]) => {
    publish(message)
  }

  return {
    publishBallots,
    ballots,
  }
}
